import { useMountEffect } from '@react-hookz/web';
import { useState, useEffect } from 'react';
import { Box, Label, Select, spacing } from '@apia/theme';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import useContext from '../../../../../../hooks/useContext';
import {
  getFiltersConditions,
  setFiltersConditions,
} from '../../../../../../store/querySlice/newApi/util/filtersConditions';
import { arrayOrArray } from '../../../../../../utils/util';
import { ApiaComponentContextPrimitive } from '../../../apiaComponent/ApiaComponentContext';

const FilterTypes = () => {
  const { fieldId } = useContext(ApiaComponentContextPrimitive);
  const dispatch = useAppDispatch();
  const { setFilterTypesConditions, setFilterTypesTitle } = useAppSelector(
    (globalState) => globalState.querySlice.queries[fieldId],
  );

  const [tempFiltersConditions, setTempFiltersConditions] = useState<
    Record<string, string>
  >({});

  useMountEffect(() => {
    void dispatch(getFiltersConditions({ fieldId }));
  });

  useEffect(() => {
    const values: Record<string, string> = {};
    setFilterTypesConditions?.forEach((element) => {
      values[element.name] = element.value;
    });
    setTempFiltersConditions(values);
  }, [setFilterTypesConditions]);

  if (!setFilterTypesConditions || !setFilterTypesTitle) return null;

  return (
    <>
      {setFilterTypesConditions.map((element) => {
        const options = arrayOrArray(element.options.option);

        return (
          <Label key={element.name}>
            <Box as="span">{element.text}:</Box>
            <Select
              title={element.title}
              sx={{ mb: spacing(2) }}
              onChange={(ev) => {
                const selectedValue = ev.target.value;
                setTempFiltersConditions((current) => {
                  const newConditions = {
                    ...current,
                    [element.name]: selectedValue,
                  };
                  void dispatch(
                    setFiltersConditions({
                      fieldId,
                      payload: newConditions,
                    }),
                  );
                  return newConditions;
                });
              }}
              disabled={element.readonly || element.disabled}
              value={tempFiltersConditions[element.name] ?? element.value}
            >
              {options.map((option) => {
                return (
                  <option value={option.value} key={option.value}>
                    {option.label}
                  </option>
                );
              })}
            </Select>
          </Label>
        );
      })}
    </>
  );
};

export default FilterTypes;
